// Why does this file exist when firebase already maintains an authenticated user?
// Because sometimes Firebase auth is flaky, and was completely down from 10-11am
// on June 12, 2025, and PDF Snake users still expect to get work done.
//
// Therefore, record which user is signed in, and they don't get signed out until
// they click the Sign Out button.

export const PERSISTENT_USER = 'PERSISTENT_USER';
